// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    receiptId: string;
    isLoading: boolean;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-OpenReceiptButtonInclude',
    templateUrl: './OpenReceiptButtonInclude.html',
    styleUrls: ['./OpenReceiptButtonInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class OpenReceiptButtonInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.OpenReceiptButtonInclude';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    input_receiptId = input(undefined, { alias: 'receiptId' });
    var_receiptId = proxySignal<string>(undefined as any);
    var_isLoading = proxySignal<boolean>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get receiptId() { return component.var_receiptId() },
                set receiptId(value: string) { component.var_receiptId.set(value) },
                get isLoading() { return component.var_isLoading() },
                set isLoading(value: boolean) { component.var_isLoading.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            receiptId: this.screen.receiptId
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_receiptId = this.dialogData?.data?.receiptId ?? this.input_receiptId() ?? (undefined)
            if (new_receiptId !== undefined) this.screen.receiptId = new_receiptId

            if (!isVariablesInitialized) this.screen.isLoading = (false)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async handler_ButtonBlock_4_click_loadAndOpen_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_loadAndOpen($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }

    async action_loadAndOpen($event?: any) {
        const { app, screen, output } = this
        {
            if (screen.isLoading) {
                return
            }

            screen.isLoading = true

            const [receipt] = await This.ExpensesDataStore.loadByCondition(This.ExpenseReceipt, {
                where: {
                    id: screen.receiptId
                },
                relations: {
                    receiptData: true
                }
            })

            screen.isLoading = false

            console.log(receipt.mimeType)

            if (!receipt) {
                return
            }

            // @ts-ignore
            const base64 = new Uint8Array(receipt.receiptData.data).toBase64()
            This.ReceiptHelper.openReceipt(base64, receipt.mimeType);
        }
    }
}
